module.exports = __webpack_public_path__ + "img/session2_card_icon5.ba483bea.png";